import explorerSaga from './Explorer';

export const crepoSagas = () => [
  explorerSaga()
];

export default crepoSagas;
